export const AtgContactUs = {
  AtgContactUs: {
    title: 'Centre client ATG',
    reason: 'Motif du contact',
    from: 'Courriel de l\'expéditeur',
    formRequired: 'Le courriel de l\'expéditeur est obligatoire',
    reasonPlaceholder: 'Sélectionnez un motif',
    reasonRequired: 'Veuillez sélectionner un motif',
    reasons: {
      unableToLogin: 'Impossible de se connecter',
      accountLocked: 'Compte utilisateur verrouillé',
      technicalIssue: 'Problème technique avec un navigateur spécifique',
      customerService: 'Service à la clientèle',
      other: 'Autre',
    },
    emailId: 'Courriel',
    emailRequired: "L'adresse courriel est obligatoire",
    emailInvalid: 'Veuillez saisir une adresse courriel valide',
    userCountry: "Pays de l'utilisateur",
    selectCountry: 'Sélectionner le pays',
    countryRequired: 'Veuillez sélectionner un pays',
    subject: 'Objet',
    subjectRequired: "L'objet est obligatoire",
    message: 'Message',
    messageRequired: 'Le message est obligatoire',
    cancel: 'Annuler',
    email: 'Courriel',
    submitError: 'Une erreur est survenue. Veuillez réessayer.',
  },
};
